export const layout = {
  employees: '従業員',
  idCards: 'Idカード',
  terminals: 'ターミナル',
  uniforms: 'ユニフォーム',
  attendanceLogs: '出席ログ',
  languages: '言語',
  announcements: 'アナウンス',
}
